import { Literals } from "shared/types";

import { TicketProgressStage } from "../types";
import TicketProgressBar from "./StatusProgress";
import { TicketAttribute } from "./TicketAttribute";

type Props = {
  status?: TicketProgressStage;
  assignee?: string;
  assigneeName?: string;
  assigneeImageSrc?: string;
  copyTexts: Literals;
};
export const TicketStatus = (props: Props) => {
  const { status, assignee, assigneeName, assigneeImageSrc, copyTexts } = props;
  if (status && assignee && assigneeName && assigneeImageSrc) {
    return (
      <div className="flex flex-col items-center justify-center space-y-2 rounded-lg pb-5">
        <img
          src={assigneeImageSrc}
          alt={assigneeName}
          className="h-12 w-12 rounded-full object-contain"
        />
        <TicketAttribute
          title={assigneeName}
          value={"is assisting you now"}
          className="text-center "
        />
        <div className="w-full pt-5">
          <TicketProgressBar status={status} assignedDate="2 days ago" />
        </div>
      </div>
    );
  }
  return (
    <div className="flex flex-col items-center space-y-2 text-center">
      <i className="ti ti-circle-check-filled text-[32px] text-green-900"></i>
      <div className="flex flex-col space-y-1">
        <p className="font-semibold">{copyTexts.ticketRaisedText}</p>
        <p className="text-xs text-secondary">
          {copyTexts.ticketUpdateNotificationText}
        </p>
      </div>
    </div>
  );
};
